(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentSupplierContract', AgentSupplierContract);

    AgentSupplierContract.$inject = ['$resource', 'DateUtils'];

    function AgentSupplierContract($resource, DateUtils) {
        var resourceUrl = 'api/agent-supplier-contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
